import React from 'react';
import { oneOf } from 'prop-types';
import cx from 'classnames';

import { getResponsivePropType, genResponsiveClasses } from './../../utils/';

const propTypes = {
  /**
    Layout direction. Stack can take enum value or media object
     `{xl: [direction], l: [direction], m: [direction], s: [direction], xs: [direction]}`.
  */
  direction: getResponsivePropType(oneOf(['horizontal', 'vertical'])),
  /** ButtonLayouts component is used for creating ButtonGroup and also Button */
  type: oneOf(['group', 'layout']).isRequired,
};

const defaultProps = {
  direction: 'vertical',
};

const ButtonLayouts = ({ className, direction, type, ...other }) => {
  let ButtonLayoutDirection = direction;
  if (typeof direction === 'object') {
    ButtonLayoutDirection = { ...{ xs: defaultProps.direction }, ...direction };
  }

  const classes = cx(
    `btn-${type}`,
    ...genResponsiveClasses(`btn-${type}`, ButtonLayoutDirection),
    className
  );

  return <div className={classes} {...other} />;
};

ButtonLayouts.displayName = 'ButtonLayouts';
ButtonLayouts.propTypes = propTypes;
ButtonLayouts.defaultProps = defaultProps;

export default ButtonLayouts;



// WEBPACK FOOTER //
// ./src/components/Button/ButtonLayouts.js